import React from 'react';
import { Package, DollarSign, ListOrdered } from 'lucide-react';
import type { RouteSummary } from '../../types/deliveryManagement';
import { formatCurrencyGBP } from '../../utils/formatNumbers';

interface RouteSummaryStatsProps {
  summary: RouteSummary;
  isVisible: boolean;
}

export const RouteSummaryStats: React.FC<RouteSummaryStatsProps> = ({ 
  summary, 
  isVisible 
}) => {
  if (!isVisible) return null;

  const formattedAmount = formatCurrencyGBP(summary.totalAmount);

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-4 mb-4">
      <div className="flex flex-wrap gap-6">
        {/* Job Count */}
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <Package className="w-5 h-5 text-white" />
            </div>
          </div>
          <div>
            <div className="text-sm text-gray-600">Total Jobs</div>
            <div className="text-2xl font-bold text-gray-900">{summary.jobCount}</div>
          </div>
        </div>

        {/* Total Amount */}
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
              <DollarSign className="w-5 h-5 text-white" />
            </div>
          </div>
          <div>
            <div className="text-sm text-gray-600">Total Revenue</div>
            <div className="text-2xl font-bold text-gray-900">{formattedAmount}</div>
          </div>
        </div>

        {/* Total Quantity */}
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-purple-500 rounded-lg flex items-center justify-center">
              <ListOrdered className="w-5 h-5 text-white" />
            </div>
          </div>
          <div>
            <div className="text-sm text-gray-600">Total Orders</div>
            <div className="text-2xl font-bold text-gray-900">{summary.totalQuantity}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
